import { useQuery } from '@tanstack/react-query';

import getGiveawayType from 'Api/brief-live/getGiveawayType';

import getGiveawayTypeResponse from './model/response/getGiveawayTypeResponse';

const useGetGiveawayType = () => {
  return useQuery({
    queryKey: ['all-giveaway-type'],
    queryFn: async () => {
      const response = await getGiveawayType();

      return getGiveawayTypeResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export default useGetGiveawayType;
